import React from 'react';

import Timer from '@common/components/timer';
import { useTranslation } from '@common/hooks/translation';

const VerificationLogoutPopup = ({ closePopup, onLogout }) => {
  const t = useTranslation();

  const logout = () => {
    onLogout();
    closePopup();
  };

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('Would you like to log out')}</h3>
      <div className="popup-main-content">
        <i className="global-icon icon-logout popup-main-icon" />
        <p className="text-center">{t('You will be logged out automatically after')}</p>
        <Timer duration={10} onFinish={logout} />
      </div>
      <div className="popup-actions">
        <button
          type="button"
          className="popup-cancel-button"
          onClick={() => closePopup()}
        >
          {t('Cancel')}
        </button>
        <button
          type="button"
          className="popup-confirm-button"
          onClick={logout}
        >
          {t('Log out')}
        </button>
      </div>
    </div>
  );
};

export default VerificationLogoutPopup;
